import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faArrowLeft, faHome, faBoxOpen, faTrash, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faWhatsappSquare } from '@fortawesome/free-brands-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer } from 'react-toastify';
import MiPedido from '../MiPedido/MiPedido';

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [name, setName] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [tienda, setTienda] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [deliveryOption, setDeliveryOption] = useState('delivery'); // solo delivery
    const [metodos, setMetodos] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [pagoRecibir, setPagoRecibir] = useState('');
    const [estado, setEstado] = useState(null);

    const [modalWhatsApp, setModalWhatsApp] = useState(false);
    const [whatsappMessage, setWhatsappMessage] = useState('¡Hola! Estoy interesado en...');
    const [address, setAddress] = useState('');

    let now = new Date();
    let offset = -5 * 60; // Colombia
    let colombiaTime = new Date(now.getTime() + offset * 60 * 1000);
    let createdAt = colombiaTime.toISOString().slice(0, 19).replace('T', ' ');

    useEffect(() => { cargarTienda() }, []);
    useEffect(() => {
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += (Number(item?.precio) || 0) * (Number(item?.cantidad) || 0);
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    useEffect(() => {
        const fetchEstado = async () => {
            try {
                const response = await fetch(`${baseURL}/estado.php?`);
                const data = await response.json();
                if (!data.error) setEstado(data.estado);
            } catch (error) {
                console.error("Error al obtener el estado:", error);
            }
        };
        fetchEstado();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setTienda(data.tienda?.reverse() || []))
            .catch(error => console.error('Error al cargar datos:', error));
    };

    useEffect(() => { cargarMetodos(); cargarProductos(); }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const items = cart.map((cartItem) => {
                const producto = productos.find(producto => producto?.idProducto === cartItem?.idProducto) || {};
                return {
                    ...producto,
                    cantidad: Number(cartItem?.cantidad || 0),
                    items: cartItem?.items || [],
                    idProducto: cartItem?.idProducto ?? producto?.idProducto,
                    stock: producto?.stock !== undefined ? Number(producto.stock) : Infinity,
                };
            });
            setCartItems(items);
            setLoading(false);
        };
        fetchCartItems();
    }, [productos, isFocused]);

    const cargarMetodos = () => {
        fetch(`${baseURL}/metodoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setMetodos((data.metodos || []).filter(m => m.estado === 'Activo')))
            .catch(error => console.error('Error al cargar datos bancarios:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setProductos(data.productos || []))
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => item?.imagen1 || item?.imagen2 || item?.imagen3 || item?.imagen4 || null;

    const openModal = () => { setModalIsOpen(true); setIsFocused(true); };
    const closeModal = () => { setModalIsOpen(false); setIsFocused(false); };
    const openModal2 = () => setModalIsOpen2(true);
    const closeModal2 = () => setModalIsOpen2(false);

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };
    const clearCart = () => { setCartItems([]); localStorage.removeItem('cart'); };

    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        const item = updatedCartItems[index];
        const current = Number(item?.cantidad || 0);
        const maxStock = Number(item?.stock ?? Infinity);

        if (current + 1 > maxStock) {
            Swal.fire({ icon: 'warning', title: 'Stock insuficiente', text: `No puedes añadir más de ${maxStock} unidades de "${item?.titulo || 'producto'}".` });
            return;
        }

        updatedCartItems[index] = { ...item, cantidad: current + 1 };
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (!updatedCartItems[index]) return;
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };

    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');
        for (let item of cartItems) {
            const cantidad = Number(item?.cantidad || 0);
            const stock = Number(item?.stock ?? Infinity);
            if (cantidad > stock) {
                Swal.fire({ icon: 'error', title: 'Cantidad mayor al stock', text: `El producto "${item?.titulo || 'producto'}" solo tiene ${stock} unidades disponibles.` });
                setMensaje(''); return;
            }
        }

        try {
            const productosPedido = cartItems.map(item => ({
                idProducto: item?.idProducto,
                idCategoria: item?.idCategoria,
                titulo: item?.titulo,
                cantidad: item?.cantidad,
                items: item?.items,
                precio: item?.precio,
                imagen: obtenerImagen(item)
            }));

            const productosPedidoJSON = JSON.stringify(productosPedido);
            let totalPriceCalc = 0;
            cartItems.forEach(item => totalPriceCalc += (Number(item?.precio) || 0) * (Number(item?.cantidad) || 0));

            const formData = new FormData();
            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceCalc);
            formData.append('nombre', name);
            formData.append('telefono', telefono);
            const entrega = (deliveryOption === 'delivery') ? address : 'Envío Digital/Online';
            formData.append('entrega', entrega);
            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            formData.append('pagado', 'No');
            formData.append('pagoRecibir', pagoRecibir);
            formData.append('createdAt', createdAt);

            const response = await fetch(`${baseURL}/pedidoPost.php`, { method: 'POST', body: formData });
            const data = await response.json();

            if (data?.idPedido) {
                setMensaje('');
                Swal.fire('Pedido enviado!', `Pedido N°${data.idPedido} creado con éxito.`, 'success');
                localStorage.setItem('idPedido', data.idPedido);
                setName(''); setCodigo(''); setNoteText('');
                closeModal(); closeModal2(); clearCart();
            } else if (data?.error) {
                setMensaje(''); Swal.fire('Error', data?.error, 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire('Error', 'Error de conexión. Por favor, inténtelo de nuevo.', 'error');
        }
    };

    return (
        <div>
            <ToastContainer />
            <button onClick={openModal} className='cartIconFixed'>
                {cartItems?.length >= 1 && <span>{cartItems.length}</span>}
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <div className="bottom-nav-bar">
                <Anchor to="/" className="nav-item"><FontAwesomeIcon icon={faHome} size="lg" /><span>Inicio</span></Anchor>
                <button onClick={() => setModalWhatsApp(true)} className="nav-item whatsapp-item"><FontAwesomeIcon icon={faWhatsappSquare} size="2x" /><span>Business</span></button>
                <button onClick={openModal} className="nav-item cart-item"><FontAwesomeIcon icon={faShoppingCart} size="lg" />{cartItems?.length >= 1 && <div className="cart-counter">{cartItems.length}</div>}<span>Carrito</span></button>
                <Anchor to="/productos" className="nav-item"><FontAwesomeIcon icon={faBoxOpen} size="lg" /><span>Productos</span></Anchor>
            </div>

            {/* Aquí van los modales (WhatsApp y Carrito) */}
            {/* ... Puedes reutilizar los bloques del código anterior asegurándote de cerrar todas las etiquetas */}
        </div>
    );
}
